<form class="-devsite-search-form" [class.expanded]="expanded" (ngSubmit)="$event.preventDefault()">
  <span class="search-input-container">
    <span class="search-icon">
      <div class="search-icon-bg"></div>
    </span>
    <input
      id="-search-input"
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      (click)="onFocus()"
      (blur)="onInputBlur($event)"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off" />
    <div class="search-util">
      @if (searchControl.value) {
      <button type="button" class="clear-button" (click)="clearSearchInput()" aria-label="Clear search">
        <lucide-icon name="x" [size]="16"></lucide-icon>
      </button>
      } @if (searchControl.value && expanded && hasResults && isResponsiveScreen) {
      <button
        type="button"
        class="responsive-filter-button"
        (click)="toggleFilterDropdown($event)"
        aria-label="Filter results">
        <lucide-icon name="settings-2" [size]="16"></lucide-icon>
      </button>
      }
    </div>
  </span>
  @if (expanded && enableBackdrop) {
  <div class="search-backdrop"></div>
  } @if (expanded && enableBackdrop) {
  <div class="results-popup" tabindex="-1">
    @if (searchResults$ | async; as results) { @if (suggestedWord || localSearchProduct || initialFacetResults) {
    <div class="action-card">
      <div class="action-row">
        @if (suggestedWord && results.ResultItems?.length === 0) {
        <div class="correction-container">
          <span class="correction-link">
            Did you mean
            <b (click)="applyCorrection(suggestedWord)">{{ suggestedWord }}</b
            >?
          </span>
        </div>
        } @if (localSearchProduct && !suggestedWord) {
        <app-local-search
          [toggleActive]="localSearchToggleActive"
          (toggleActiveChange)="onLocalSearchToggleChange($event)"
          [localSearchProduct]="localSearchProduct"
          (localSearchProductEmitter)="localSearchProductHandler($event)">
        </app-local-search>
        } @if ((!suggestedWord && (results.ResultItems?.length !== 0)) || initialFacetResults) {
        <app-filter
          [filterValues]="filterList"
          [facetResponse]="initialFacetResults"
          [selectedValues]="selectedFilterValues"
          (selectionChange)="onSelectionChange($event)">
        </app-filter>
        }
      </div>
    </div>
    } @if (results.ResultItems?.length === 0 || noResultMode) {
    <div class="no-results-container">
      <div class="no-results-text">No results</div>
      <div class="no-results-text">
        Try using other terms, use our
        <app-link [to]="solutionFinderResponse.path" class="no-results-link">Solution Finder, </app-link>
        or
        <app-link [to]="solutionFinderResponse.contactSupport" class="no-results-link">Contact Support</app-link>
      </div>
    </div>
    } @if (results.ResultItems?.length > 0 && !noResultMode) {
    <div class="result-container">
      @for (searchResult of results.ResultItems | slice : 0 : resultSliceCount; track searchResult) {
      <div class="result-item">
        <app-search-card
          (clearSearchInput)="clearSearchInput()"
          [searchCardResponse]="searchResult"
          [isLoading]="isLoading"
          [showSkeleton]="isLoading"></app-search-card>
      </div>
      }
    </div>
    } @if (showAllResults && !noResultMode && !isLoading) {
    <a href="/results" (click)="onShowAll($event)" class="show-all-results-link"> Show all results </a>
    } }
    <solution-finder-card class="solutionfinder-card" [solutionFinderResponse]="solutionFinderResponse">
    </solution-finder-card>
    <div class="search-info-card">
      <div class="search-info-header">
        <div class="ai-icon-bg"></div>
        AI-powered search results
      </div>
      <p>Search results are generated by AI. <app-link [to]="'/terms-of-service'">Learn more</app-link></p>
    </div>
  </div>
  }
</form>
